const cartDrawer = document.querySelector('.cart-drawer-content');
const cartButton = document.querySelector('.js-drawer-open-cart');

let previouslyFocused = null;

function handleCartDrawerKeydown(e) {
  if (e.key === 'Escape') {
    e.preventDefault();
    closeDrawer();
  }
}

function getHeaderSectionId() {
	const headerRoot = document.querySelector('[data-section-type="header"]');
	const sectionWrapper = headerRoot?.closest('[data-section-id]');
	return sectionWrapper?.getAttribute('data-section-id') || null;
}

function syncElementAttributes(target, source) {
  if (!target || !source) return;
  Array.from(target.attributes).forEach(attr => {
    if (!source.hasAttribute(attr.name)) {
      target.removeAttribute(attr.name);
    }
  });
  Array.from(source.attributes).forEach(attr => {
    target.setAttribute(attr.name, attr.value);
  });
}

function updateElementContent(currentEl, newEl, options = {}) {
  if (!currentEl || !newEl) return;
  const preserveSelectors = options.preserveSelectors || [];
  const preservedContent = preserveSelectors
    .map(selector => {
      const currentNode = currentEl.querySelector(selector);
      const newNode = newEl.querySelector(selector);
      if (!currentNode || !newNode) return null;
      return {
        selector,
        clone: currentNode.cloneNode(true),
        newNode
      };
    })
    .filter(Boolean);

  syncElementAttributes(currentEl, newEl);
  if (currentEl.innerHTML !== newEl.innerHTML) {
    currentEl.innerHTML = newEl.innerHTML;
  }

  preservedContent.forEach(({ selector, clone, newNode }) => {
    const replacement = currentEl.querySelector(selector);
    if (!replacement || !clone) return;
    syncElementAttributes(clone, newNode);
    replacement.replaceWith(clone);
  });
}

function updateUpsellVisibility(nextDrawer) {
  if (!cartDrawer || !nextDrawer) return;
  const currentUpsell = cartDrawer.querySelector('[data-upsell-block]');
  const newUpsell = nextDrawer.querySelector('[data-upsell-block]');
  if (!currentUpsell || !newUpsell) return;
  const visibleAttr = newUpsell.getAttribute('data-upsell-visible');
  const shouldShow = visibleAttr !== 'false';

  currentUpsell.setAttribute('data-upsell-visible', shouldShow ? 'true' : 'false');
  currentUpsell.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

  if (shouldShow) {
    currentUpsell.style.removeProperty('display');
  } else {
    currentUpsell.style.display = 'none';
  }
}

function replaceCartDrawerFromHTML(htmlString) {
  const temp = document.createElement('div');
  temp.innerHTML = htmlString;
  const nextDrawer = temp.querySelector('.cart-drawer-content');
  
  if (nextDrawer && cartDrawer) {
    // Update only specific sections that might have changed
    const sectionsToUpdate = [
      {
        selector: '[data-cart-body]',
        preserveSelectors: ['[data-upsell-block]']
      },
      {
        selector: '[data-order-summary]'
      },
      {
        selector: '[data-promo-offer-panel]'
      }
    ];

    sectionsToUpdate.forEach(({ selector, preserveSelectors }) => {
      const currentSection = cartDrawer.querySelector(selector);
      const newSection = nextDrawer.querySelector(selector);
      updateElementContent(currentSection, newSection, { preserveSelectors });
    });

    updateUpsellVisibility(nextDrawer);
  }
}

async function refreshCartDrawer() {
  try {
    const headerSectionId = getHeaderSectionId();
    if (!headerSectionId) return;

    const url = `${window.location.pathname}?section_id=${headerSectionId}`;
    const res = await fetch(url, { 
      credentials: 'same-origin', 
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    const text = await res.text();

    replaceCartDrawerFromHTML(text);

    document.dispatchEvent(new CustomEvent('cart:drawer:refreshed'));

    if (window.GiftPromo) {
      window.GiftPromo.disableCheckout();
      const giftActionTaken = await window.GiftPromo.checkAndManageGift(refreshCartDrawer);
      if (!giftActionTaken) {
        window.GiftPromo.enableCheckout();
      }
    }
  } catch (e) {
    console.error('Cart drawer refresh failed', e);
    if (window.GiftPromo) window.GiftPromo.enableCheckout();
  }
}

async function openDrawer(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  if (!cartDrawer) return;

  previouslyFocused = document.activeElement;

  try {
    cartDrawer.classList.add('updating');

    cartDrawer.classList.add('open');
    document.body.classList.add('cart-drawer-open');

    document.addEventListener('keydown', handleCartDrawerKeydown);

    const focusTarget = cartDrawer.querySelector('.drawer__close-button');
    if (focusTarget) {
      setTimeout(() => focusTarget.focus(), 50);
    }

    await refreshCartDrawer();

  } catch (error) {
    console.error('Failed to open cart drawer:', error);
  } finally {
    cartDrawer.classList.remove('updating');
  }
}

function closeDrawer(e) {
	if (e) {
		e.preventDefault();
		e.stopPropagation();
	}
	if (!cartDrawer) return;
	cartDrawer.classList.remove('open');
	document.body.classList.remove('cart-drawer-open');

	document.removeEventListener('keydown', handleCartDrawerKeydown);

	if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
		previouslyFocused.focus();
		previouslyFocused = null;
	}
}

async function onRemoveClick(evt) {
  const removeBtn = evt.target.closest(".cart__remove");
  if (!removeBtn || !cartDrawer.contains(removeBtn)) return;
  evt.preventDefault();
  
  const key = removeBtn.getAttribute("data-remove-item");
  if (!key) return;
  
  const itemWrapper = removeBtn.closest('.cart__item');
  if (itemWrapper) {
    setLoadingState(itemWrapper, true);
  }
  
  if (window.GiftPromo) window.GiftPromo.disableCheckout();

  try {
    if (window.theme?.cart?.changeItem) {
      await window.theme.cart.changeItem(key, 0);
    } else {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
    }

    await refreshCartDrawer();
  } catch (error) {
    console.error('Failed to remove item:', error);
    if (window.GiftPromo) window.GiftPromo.enableCheckout();
  } finally {
    if (itemWrapper) {
      setLoadingState(itemWrapper, false);
    }
  }
}

async function submitQtyChange(wrapper, nextQty) {
  const input = wrapper.querySelector(".js-qty__num");
  if (!input) return;
  
  const key = input.getAttribute("data-id");
  const qty = Number(nextQty ?? input.value);
  if (!key || Number.isNaN(qty)) return;

  setLoadingState(wrapper, true);
  if (window.GiftPromo) window.GiftPromo.disableCheckout();

  try {
    if (window.theme?.cart?.changeItem) {
      await window.theme.cart.changeItem(key, qty);
    } else {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
    }

    await refreshCartDrawer();
  } catch (error) {
    console.error('Failed to update quantity:', error);
    if (window.GiftPromo) window.GiftPromo.enableCheckout();
  } finally {
    setLoadingState(wrapper, false);
  }
}

function setLoadingState(wrapper, isLoading) {
  if (isLoading) {
    wrapper.classList.add('updating');
  } else {
    wrapper.classList.remove('updating');
  }
}

function onQtyInput(evt) {
  const input = evt.target.closest('.js-qty__num');
  if (!input || !cartDrawer.contains(input)) return;
  const wrapper = input.closest('.js-qty__wrapper');
  if (!wrapper) return;
  clearTimeout(wrapper._qtyDebounce);
  wrapper._qtyDebounce = setTimeout(async () => {
    await submitQtyChange(wrapper);
  }, 400);
}

async function onQtyAdjustClick(evt) {
  const btn = evt.target.closest('.js-qty__adjust');
  if (!btn || !cartDrawer.contains(btn)) return;
  evt.preventDefault();
  
  const wrapper = btn.closest('.js-qty__wrapper');
  if (!wrapper) return;
  const input = wrapper.querySelector('.js-qty__num');
  if (!input) return;
  
  const current = Number(input.value) || 0;
  const next = btn.classList.contains('js-qty__adjust--plus') 
    ? current + 1 
    : Math.max(0, current - 1);
  
  input.value = String(next);
  await submitQtyChange(wrapper, next);
}

function bindDrawerInternalEvents() {
	if (!cartDrawer) return;

	cartDrawer.addEventListener('click', (event) => {
		if (event.target.closest('.drawer__close')) {
			closeDrawer(event);
			return;
		}
		onRemoveClick(event);
		onQtyAdjustClick(event);
	});

	cartDrawer.addEventListener('input', onQtyInput);

  // const upsellEl = cartDrawer.querySelector(".essential-upsell-cross-sell-block");
  // if (upsellEl) {
  //   upsellEl.addEventListener(
  //     "click",
  //     function onUpsellAdd(e) {
  //       const btn = e.target.closest(
  //         '[data-essential-upsell-element="add-to-cart-button"]'
  //       );
  //       if (!btn || !upsellEl.contains(btn)) return;
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       const productRoot = btn.closest(
  //         '[data-essential-upsell-element="product"]'
  //       );
  //       const upsellAdd = (id) =>
  //         fetch("/cart/add.js", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //           body: JSON.stringify({
  //             items: [{ id: Number(id), quantity: 1 }],
  //           }),
  //         })
  //           .then(() => refreshCartDrawer())
  //           .catch(() => refreshCartDrawer());
  //       const linkEl = productRoot?.querySelector(
  //         '[data-essential-upsell-element="title"]'
  //       );
  //       const href = linkEl?.getAttribute("href") || "";
  //       const match = href.match(/\/products\/([^\/?#]+)/i);
  //       const handle = match ? match[1] : null;
  //       if (!handle) return;
  //       fetch(`/products/${handle}.js`, { credentials: "same-origin" })
  //         .then((res) => res.json())
  //         .then(btn.querySelector('[data-essential-upsell-element="icon"]').classList.add('btn--loading'))
  //         .then((product) => {
  //           const firstAvailable = Array.isArray(product?.variants)
  //             ? product.variants.find((variant) => variant?.available) ||
  //               product.variants[0]
  //             : null;
  //           if (firstAvailable?.id) return upsellAdd(firstAvailable.id);
  //         })
  //         .catch(() => refreshCartDrawer());
  //     },
  //     { capture: true, passive: false }
  //   );
  // }
	document.addEventListener('click', function handleOutsideClick(event) {
		if (!cartDrawer.classList.contains('open')) return;
		if (cartDrawer.contains(event.target)) return;
		closeDrawer();
	});
}

if (cartButton) {
	cartButton.addEventListener('click', openDrawer);
}

// Allow other components (e.g. Build Your Collection) to refresh the drawer contents
document.addEventListener('cart:refresh', () => {
	refreshCartDrawer();
});

bindDrawerInternalEvents();

// JS is ready: add to cart goes through ajax, drop the no-JS return_to
document.querySelectorAll('[data-no-js-return]').forEach(input => input.remove());

// Back from a no-JS add to cart (return_to=...?cart=open): open the drawer
(function openFromUrl() {
  const url = new URL(window.location.href);
  if (url.searchParams.get('cart') !== 'open') return;
  url.searchParams.delete('cart');
  window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  openDrawer();
})();